import React from 'react';
import { Grid, Typography, Box } from '@mui/material';
import parse from 'html-react-parser';

import LazyImage from '../../../Layouts/LazyImage';

const LotToDo = ({ data }) => {
  return (
    <Box mt={5}>
      <Typography align="center" variant="h5">
        {data?.title}
      </Typography>

      <Box mt={7} />
      {data?.items.map((item, key) => (
        <Box mt={4} key={key}>
          <Grid
            container
            sx={{
              alignItems: 'center',
              justifyContent: 'center',
              flexDirection: key % 2 === 0 ? 'row-reverse' : '',
            }}
            spacing={4}
          >
            <Grid item xs={8} md={3}>
              <Box maxWidth="240px" mx="auto">
                <LazyImage sizes={sizes} src={item?.icon} />
              </Box>
            </Grid>{' '}
            <Grid item xs={11} md={8}>
              <Typography variant="body1">{parse(item?.title)}</Typography>
            </Grid>
          </Grid>
        </Box>
      ))}
    </Box>
  );
};

const sizes = {
  xxl: [197, 197, false],
};

export default LotToDo;
